// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* overridden by src/lib/themes/guiHelpers.js */

.dash-collaboration-status_status_Ko01Q {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    min-height: 2rem;
    padding: 0.25rem 0.75rem;
    background: var(--ui-tertiary);
    color: var(--text-primary);
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-size: 0.8125rem;
}

.dash-collaboration-status_error_AD67n {
    color: var(--error-light);
}

.dash-collaboration-status_button_kqMdp {
    padding: 0.25rem 0.625rem;
    border: 1px solid var(--ui-black-transparent);
    border-radius: 0.25rem;
    background: var(--ui-primary);
    color: var(--text-primary);
    font: inherit;
    cursor: pointer;
}

.dash-collaboration-status_members_JUwMB {
    margin-left: auto;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
`, "",{"version":3,"sources":["webpack://./src/components/dash-collaboration-status/dash-collaboration-status.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,wBAAwB;IACxB,8BAA8B;IAC9B,0BAA0B;IAC1B,2DAA2D;IAC3D,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,6CAA6C;IAC7C,sBAAsB;IACtB,6BAA6B;IAC7B,0BAA0B;IAC1B,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB","sourcesContent":["/* overridden by src/lib/themes/guiHelpers.js */\n\n.status {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n    min-height: 2rem;\n    padding: 0.25rem 0.75rem;\n    background: var(--ui-tertiary);\n    color: var(--text-primary);\n    font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n    font-size: 0.8125rem;\n}\n\n.error {\n    color: var(--error-light);\n}\n\n.button {\n    padding: 0.25rem 0.625rem;\n    border: 1px solid var(--ui-black-transparent);\n    border-radius: 0.25rem;\n    background: var(--ui-primary);\n    color: var(--text-primary);\n    font: inherit;\n    cursor: pointer;\n}\n\n.members {\n    margin-left: auto;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
export var status = `dash-collaboration-status_status_Ko01Q`;
export var error = `dash-collaboration-status_error_AD67n`;
export var button = `dash-collaboration-status_button_kqMdp`;
export var members = `dash-collaboration-status_members_JUwMB`;
export default ___CSS_LOADER_EXPORT___;
